import { Badge } from '@startupquickstart/frontend';
import type { ComponentPropsWithoutRef } from 'react';

type PromotionalOfferStatus = 'published' | 'draft';

interface PromotionalOfferStatusBadgeProps
  extends Omit<ComponentPropsWithoutRef<typeof Badge>, 'variant'> {
  status: PromotionalOfferStatus;
}

function getStatusConfig(status: PromotionalOfferStatus) {
  switch (status) {
    case 'published':
      return {
        variant: 'default' as const,
        label: 'Published',
      };
    case 'draft':
      return {
        variant: 'secondary' as const,
        label: 'Draft',
      };
    default:
      return {
        variant: 'outline' as const,
        label: 'Unknown',
      };
  }
}

export function PromotionalOfferStatusBadge({
  status,
  className,
  ...props
}: PromotionalOfferStatusBadgeProps) {
  const { variant, label } = getStatusConfig(status);

  return (
    <Badge variant={variant} className={className} {...props}>
      {label}
    </Badge>
  );
}
